import {
  BreakdownType,
  CalculationInputDto,
  CalculationResultDto,
  Region,
} from "../models/calculation-api.types";
import axios from "axios";

const MOCK = false;

export const CalculatorApi = {
  async calculate(payload: CalculationInputDto, apiUrl: string): Promise<CalculationResultDto> {
    if (MOCK) {
      return await this.calculateMock(payload);
    }

    const response = await axios.post<CalculationResultDto>(
      `${apiUrl}/calculation/calculate`,
      payload
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },

  async calculateMock(
    payload?: CalculationInputDto
  ): Promise<CalculationResultDto> {
    return new Promise((response) => {
      setTimeout(() => {
        response({
          region: Region.Flanders,
          result: {
            totalAmount: 441.97,
            children: [
              {
                name: "Pumba",
                totalAmount: 441.97,
                breakdown: [
                  {
                    type: BreakdownType.Basis,
                    amount: 166.46,
                  },
                  {
                    type: BreakdownType.Wees,
                    amount: 83.3,
                  },
                  {
                    type: BreakdownType.Mindervalide,
                    amount: 192.21,
                  },
                  {
                    type: BreakdownType.Toeslag,
                    amount: 0,
                  },
                ],
                calculationStrategy: "NewCalculationStrategy",
              },
              {
                name: "Zita",
                totalAmount: 192.46,
                breakdown: [
                  {
                    type: BreakdownType.Basis,
                    amount: 192.46,
                  },
                  {
                    type: BreakdownType.Wees,
                    amount: 0,
                  },
                  {
                    type: BreakdownType.Mindervalide,
                    amount: 0,
                  },
                  {
                    type: BreakdownType.Toeslag,
                    amount: 0,
                  },
                ],
                calculationStrategy: "NewCalculationStrategy",
              },
            ],
          },
        });
      }, 0);
    });
  },
};
